export default {
  header: {
    title: "My Projects",
    subtitle: "Manage your cloud infrastructure projects",
    newProject: "New Project"
  },
  search: {
    placeholder: "Search for a project..."
  },
  filters: {
    allProviders: "All providers",
    allTags: "All tags",
    showArchived: "Show archived projects",
    sortByDate: "Sort by date",
    sortByName: "Sort by name",
    sortByArchitectures: "Sort by architectures",
    ascending: "Ascending",
    descending: "Descending"
  },
  providers: {
    azure: "Azure",
    aws: "AWS",
    gcp: "GCP",
    all: "All"
  },
  selection: {
    selected: "project selected",
    selected_plural: "projects selected",
    selectAll: "Select all",
    deselectAll: "Deselect all",
    deselectTitle: "Deselect all"
  },
  buttons: {
    dashboard: "Dashboard",
    import: "Import",
    export: "Export",
    exportSelected: "Export",
    exportTitle: "Export selected projects",
    selectProjectsToExport: "Select projects to export"
  },
  views: {
    grid: "Grid view",
    list: "List view"
  },
  empty: {
    noProjects: "No projects",
    noProjectsDescription: "Create your first project to get started",
    createProject: "Create project",
    noResults: "No projects found",
    noResultsDescription: "Try modifying your search criteria"
  },
  card: {
    architectures: "architectures",
    archived: "Archived"
  },
  table: {
    project: "Project",
    provider: "Provider",
    architectures: "Architectures",
    lastModified: "Last modified",
    createdBy: "Created by",
    actions: "Actions"
  },
  actions: {
    edit: "Edit",
    duplicate: "Duplicate",
    archive: "Archive",
    unarchive: "Unarchive",
    delete: "Delete"
  },
  dates: {
    today: "Today",
    yesterday: "Yesterday",
    daysAgo: "{{count}} days ago"
  },
  modal: {
    createTitle: "New Project",
    editTitle: "Edit project",
    nameLabel: "Project name",
    nameRequired: "Project name *",
    namePlaceholder: "Ex: Production Infrastructure",
    descriptionLabel: "Description",
    descriptionPlaceholder: "Describe your project...",
    providerLabel: "Cloud Provider",
    tagsLabel: "Tags",
    tagsPlaceholder: "Add a tag...",
    providerAzure: "Microsoft Azure",
    providerAWS: "Amazon Web Services",
    providerGCP: "Google Cloud Platform",
    cancel: "Cancel",
    create: "Create",
    save: "Save",
    nameRequiredError: "Project name is required"
  },
  messages: {
    deleteTitle: "Delete Project",
    confirmDelete: "Are you sure you want to delete this project?",
    confirmDeleteProject: "Are you sure you want to delete the project \"{{name}}\"? This action is irreversible.",
    createSuccess: "✅ Project created successfully in database!",
    updateSuccess: "✅ Project updated successfully!",
    deleteSuccess: "✅ Project deleted successfully!",
    archiveSuccess: "✅ Archive status updated successfully!",
    createError: "❌ Error: {{error}}\n\nPlease check that you are connected.",
    updateError: "❌ Error updating: {{error}}",
    deleteError: "❌ Error deleting: {{error}}",
    archiveError: "❌ Error archiving: {{error}}",
    exportSelectAtLeastOne: "Please select at least one project to export.",
    exportSuccess: "✅ {{count}} project(s) exported successfully!",
    exportError: "❌ Export error: {{error}}",
    exportProjectError: "Error exporting project \"{{name}}\". Continuing with other projects...",
    importSuccess: "✅ {{successCount}} project(s) imported successfully!",
    importSuccessWithErrors: "✅ {{successCount}} project(s) imported successfully!\n⚠️ {{errorCount}} project(s) failed.",
    importNoProjects: "❌ No projects could be imported.",
    importError: "❌ Import error: {{error}}",
    importInvalidFile: "❌ File \"{{filename}}\" is not a valid GenIaC project export.",
    importInvalidFormat: "❌ This file is not a GenIaC project export. Please import a valid project file.",
    importUnsupportedFormat: "❌ Unsupported file format. Please import a .json or .zip file",
    importNoValidProjects: "❌ No valid projects found in the file."
  },
  console: {
    loadingProjects: "📡 Loading projects from API...",
    projectsLoaded: "✅ Projects loaded:",
    mappedProjects: "📊 Projects mapped:",
    loadError: "❌ Error loading projects:",
    fallbackLocalStorage: "⚠️ Fallback to localStorage",
    noProjects: "⚠️ No projects available",
    creatingProject: "📡 Creating project via API...",
    projectCreated: "✅ Project created successfully:",
    createError: "❌ Error creating project:",
    updatingProject: "📡 Updating project via API...",
    projectUpdated: "✅ Project updated successfully",
    updateError: "❌ Error updating:",
    deletingProject: "📡 Deleting project via API...",
    projectDeleted: "✅ Project deleted successfully",
    deleteError: "❌ Error deleting:",
    archivingProject: "📡 Archiving project via API...",
    projectArchived: "✅ Project archived successfully",
    archiveError: "❌ Error archiving:",
    exportingProjects: "📦 Exporting {{count}} project(s) with their architectures...",
    projectArchitectures: "✅ Project \"{{name}}\": {{count}} architecture(s) found",
    fetchingArchDetails: "📦 Fetching complete details for architecture \"{{name}}\"...",
    archDetailsError: "❌ Error fetching architecture {{name}}:",
    completeArchitectures: "✅ Project \"{{name}}\": {{count}} complete architecture(s) loaded",
    exportProjectError: "❌ Error exporting project {{name}}:",
    exportError: "❌ Export error:",
    importingProjects: "📦 Importing {{count}} project(s)...",
    projectCreatedWithId: "✅ Project \"{{name}}\" created with ID: {{id}}",
    architecturesImported: "✅ {{count}} architecture(s) imported",
    importArchError: "❌ Error importing architecture \"{{name}}\":",
    importProjectError: "❌ Error importing project:",
    importError: "❌ Import error:"
  }
};
